
import Vue from 'vue'

export default Vue.extend({
   name: 'CurrencyComponent',
   props: {
      value: { type: Number, default: 0 },
      symbol: { type: String, default: '$' },
      currency: { type: String, default: '' },
      showCurrency: { type: Boolean, default: false },
   },
   computed: {
      displayValue(): string {
         return this.value.toFixed(2)
      },
   },
})
